import React from "react";

import ReviewAction from "../ReviewAction";

const NotificationAction = props => {
	return (
		<ReviewAction {...props} isNotification={true}/>
	);
};

export default NotificationAction;
